import { Link, useRouteMatch } from "react-router-dom";
import QuizPartner from "../QuizPartner";
import React from "react";
import "./style.scss";
import { useLocaleContext } from "../../context/LocaleContext";

function getPointsLabel(quantity) {
    const lastDigit = quantity % 10;
    const lastTwoDigits = quantity % 100;

    if (lastDigit === 1 && lastTwoDigits !== 11) {
        return `point.1`;
    } else if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
        return `point.2`;
    } else {
        return `point.5`;
    }
}

export default ({ quiz }) => {
    const { localeName, getLocale, getLocaleProperty } = useLocaleContext();
    const { url } = useRouteMatch();
    let style = {};
    let className = 'quiz-article';

    if (quiz.textColor) {
        style['--quiz-text-color'] = "#" + quiz.textColor;
    }
    if (quiz.backgroundImageUrl) {
        style.backgroundImage = `url(${quiz.backgroundImageUrl})`;
    }
    if (quiz.backgroundColor) {
        style.backgroundColor = '#' + quiz.backgroundColor;
    }
    if (quiz.displaySize > 100) {
        style.width = quiz.displaySize + 'px';
    } else if (quiz.displaySize === 0) {
        className += ' quiz-article-span-wide';
    } else if (quiz.displaySize > 0) {
        className += ` quiz-article-span-${quiz.displaySize}`;
    }

    return (
        <article className={className} style={style}>
            <div>
                {quiz.posterUrl && (
                    <img className={"quiz-poster"} src={quiz.posterUrl} />
                )}
                <main className="quiz-main">
                    <div className="quiz-title">
                        {getLocaleProperty(quiz, 'title')}
                    </div>
                    <div className="quiz-description">
                        {getLocaleProperty(quiz, 'description')}
                    </div>
                </main>
                <div className={"quiz-partners" + (quiz.partnersDisplay ? ` quiz-partners-${quiz.partnersDisplay}` : '')}>
                    {quiz.partners.map((partner) => (
                        <QuizPartner key={partner.id} partner={partner} />
                    ))}
                </div>
            </div>
            <div>
                <Link
                    to={`${url}/${quiz.quizKey}?lang=${localeName}`} className={`quiz-join-link`}
                    style={{ backgroundColor: "#" + (quiz.buttonColor || '999999') }}
                >
                    {getLocaleProperty(quiz, 'buttonText', getLocale('quiz.joinButton'))}
                </Link>
                {quiz.showPointsQuantity && (
                    <div className="quiz-points">
                        {quiz.pointsQuantity} {getLocale(`quiz.quantity.${getPointsLabel(quiz.pointsQuantity)}`)}
                    </div>
                )}
            </div>
        </article>
    );
}
